import { IApiError } from '@/models/apiError.model';
import { IBlogPost } from '@/models/blogPost.model';
import { IPaginationResponse } from '@/models/pagination.model';

export const SLICE_NAME = 'blogPosts';

export interface BlogPostsState {
  blogPosts: IBlogPost[] | null;
  pagination: IPaginationResponse | null;
  search: string | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: BlogPostsState = {
  blogPosts: null,
  pagination: null,
  isLoading: false,
  search: '',
  error: null,
};
